import { customElement } from "lit/decorators.js";
import { Paragraph } from "@/components/paragraph";

@customElement("eko-divider-text")
export class DividerText extends Paragraph {
  constructor() {
    super();
    this.as = "span";
    this.size = "md";
    this.weight = "medium";
    this.theme = "weak";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-divider-text": DividerText;
  }
}

export default DividerText;
